import React, { Profiler } from 'react'

import IDashboard from "../components/dashboard"
import DBranchDetails from "../components/branch/details"
import IPolicyEnq from "../components/Policy"
import IPolicyEnqDetails from "../components/Policy/details"
import IReport from '../components/Report'
import Illustrations from '../components/illustration'
import IllustrationDetails from '../components/illustration/details'
import Logout from '../components/auth/logout'

const callback = (id, phase, actualDuration, startTime, 
    baseDuration, commitTime, interactions) => {
    console.log(
      "id " + id + 
      " startTime " + startTime + 
      " actualDuration " + actualDuration +
      " baseDuration " + baseDuration + 
      " commitTime " + commitTime + 
      " phase " + phase + 
      " interactions " + interactions
    );
}

const DashboardRoutes = [
    {
        id:1,
        exact:true,
        link:'/dashboard',
        path:'/',
        //component: <Profiler id='Dashboard' onRender={callback}><IDashboard /></Profiler>,
        component: <IDashboard />,
        Route:'Route',
        name: 'Dashboard'
    },
    {
        id:2,
        exact: true,
        path:'/branchDetails',
        component: <DBranchDetails/>,
        Route: 'Route',
        name: 'Policy Enquiry'
    },
    {
        id:3,
        exact:true,
        link:'/dashboard/policyEnq',
        path:'/policyEnq',
        component:<IPolicyEnq />,
        Route:'Route',
        name: 'Policy Enquiry'
    },
    {
        id:4,
        exact:true,
        path:'/policyEnq/details',
        component: <IPolicyEnqDetails />,
        Route: 'Route',
        name: 'Policy Enquiry Details'
    },
    {
        id:7,
        exact:true,
        link:'/dashboard/illustration',
        path:'/illustration',
        component:<Illustrations />,
        Route:'Route',
        name: 'Illustrations'
    },
    {
        id:8,
        exact:true,
        path:'/illustration/details',
        component:<IllustrationDetails />,
        Route:'Route',
        name: 'Illustrations'
    }
]

const ReportRoutes = [
    {
        id:5,
        exact:true,
        link:'/dashboard/branchDetails/reports',
        path:'/branchDetails/reports',
        component: <IReport />,
        Route:'Route',
        name: 'Report'
    }
]

const ProfileRoutes = [
    {
        id:6,
        exact:true,
        link:'/auth/logout',
        //path:'/logout',
        component: <Logout />,
        Route: 'Route',
        name: 'Logout'
    }
]


export {ReportRoutes, DashboardRoutes, ProfileRoutes}